import { Injectable } from '@angular/core';
import { BaseHttpService } from '../../shared/services/base-http.service';
// import { Observable } from 'rxjs/Rx';
import { Store } from '@ngrx/store';
import { Response, Headers, RequestOptionsArgs, RequestOptions, Http, ResponseContentType } from '@angular/http';
import { IApplicationState } from '../../stateManagement/states/applicationState';

import { IResponse, IError } from '../../shared/types';
import { environment } from '../../../environments/environment';


@Injectable()

export class DashboardService extends BaseHttpService {

    constructor(private http: Http, store: Store<IApplicationState>) {
        super(store);
    }

    private getFullUrl(url: string): string {
        return environment.API_ENDPOINT + url;
    }

    getDashboard() {
        return this.http.get(`user/${this.userId}/dashboard`, this.authorizedHttpOptions())
            .map(res => this.updateLocalAuthentication(res.json()));
    }

    public getStarters(): any {
        return this.starterIds;
    }

    public getOffboarders(): any {
        return this.offboardeeIds;
    }

    public getWelcomeMessage(): any {

        //console.log(this.welcomemessage);

        if(this.welcomemessage != undefined) {
            return this.welcomemessage;
        } else if(this.starterId > 0 && this.starterFirstName != undefined) {
            return "Welcome " + this.starterFirstName + ' ' + this.starterSurname;
        } else if (this.offboardeeFirstName != undefined) {
            return "Welcome " + this.offboardeeFirstName + ' ' + this.offboardeeSurname;
        }
        return "Welcome";
    }



}



// WEBPACK FOOTER //
// ./src/app/shared/services/dashboard.service.ts